export default {
    state: {
        nameApp: 'Subscription',
        version: '0.0.1',
        environments: [
            {
                name: 'development',
                urlApiBackend: 'http://10.10.38.43:8002/api/',
            },
            {
                name: 'production',
                urlApiBackend: 'https://api.suscripcion.aceschile.cl/api/',
            },
        ],
        headers: {
			Accept: 'application/json',
			Authorization: '',
            AuthorizationFront: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiY2NkYzYxNDI4ZDM5YjNiY2M3YTc3OTBiZGNiM2Q2OTMyY2EzOTVkNTY0ZmIxNjJjMDVjZjMxNzI0MDMxYmM1ZmUwODcyOGEzOWYzZTNmMzgiLCJpYXQiOjE2NDkxNzQ1MzYsIm5iZiI6MTY0OTE3NDUzNiwiZXhwIjoxNjgwNzEwNTM2LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.RairGjtk_tbS_Qt3z7LyRTKQfKQcEskWxt0YqlB0YfYNDVEHEKldL_RuEZY9TvGOgEO1oPlbS2jl-RP6PR4tDZHgqtGIoLEvmB6PTzH-a0_cL5JuG7QooPWi1YISaWRCtPJdGEws2D81th0s4GiZzRpE71Cd-4w-gpqptOgiSfU-BMowYYDt5ibmOHhaBJuqFmYBbBq8SSqET7tPkvZwY68MIjV61W8yDLOcw7pO3E4cSi9JG8Vzxliu5CSrjMG_8iDBARl0PaRZ0mfKR4wuIfNcEEDo9I_p8qEioEFNwbbsweu3B474TKguZFYMMwZzcbZm29XkLR2glLnPnylJFg-zInvjpP27EYDe3d-Xh1w8rnnLmJllC0fb3A3__ckZr_DwvuBIH-c9v-KGQrwTZqVLwyT05PPo-WwbYp1SjIBJ7CoVxghxSDIW4LL6maUgK4o_m66tBrapYTyO7Z1tVMDRKtrrPnFK8eBv4jNUOFqGgXRfUoiKULILxMFxzyQVAy3ou2PXAL5qFBHoJWWreg54n__NoNWQmjfp2YHJnMqTg4bXuNwSWG1pEoDuJbiddFRNrHtb0Fp7wsCxqP1I-1OeEeoHuY_eA2cPOkaw64Pp8fAg0Cc4WWs_D_lDKcwuO79m2Gcz3UI6dVyzGiZdW3Sc8iJdS_a3BCGXTZ0-Vx4'
		},
    },
    mutations: {
        setHeadersAuthorization(state, token) { state.headers.Authorization = 'Bearer ' + token },
        setHeadersAuthorizationFront(state, token) { state.headers.AuthorizationFront = 'Bearer ' + token },
    },
    getters: { 
        getEnvironment: state => {
            return process.env.NODE_ENV
        },
        getEnvironmentCurrent: state => {
            let environment = process.env.NODE_ENV
            if(environment == 'development') {
                environment = (localStorage.getItem('environment') != null) ? localStorage.getItem('environment') : environment
            }
            return environment
        },
        getApiBackend: (state, getters) => {
			let environment = getters.getEnvironmentCurrent
            let index = state.environments.map((el) => el.name).indexOf(environment)
            index = (index == -1) ? 0 : index
            return state.environments[index].urlApiBackend
        },
        getHeaders: state => { return state.headers },
    },
    actions: { },
    modules: { },
};